import React, { Component } from 'react';
import Summary from '../components/Summary';
import MontemarSummary from './MontemarSummary';
import MontemarOnlineSummary from './MontemarOnlineSummary';
import ContractsContainer from '../containers/ContractsContainer';
import { Col, Row } from 'react-bootstrap';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import Section from './Section.js'
import FlowProgressBar from "./FlowProgressBar";
import LeadInfo from './LeadInfo.js';
import { FormattedHTMLMessage } from 'react-intl';

require(`../assets/${process.env.PAGE}/css/components/CheckOut.css`);

import axios from 'axios';

class CheckOut extends Component {

    constructor(props) {
        super(props);
        this.state = {
            digital_loan: null,
        };
    }

    componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/leads/digital`, config)
            .then(res => {
                const data = res.data;
                this.setState({
                    ...this.state,
                    digital_loan: data.result,
                })
            }
            );
    }

    render() {
        const { clientName } = this.props;
        let summaryComponent;

        switch (process.env.PAGE) {
            case 'montemar':
                if (this.state.digital_loan) {
                    summaryComponent = (<MontemarOnlineSummary />);
                } else {
                    summaryComponent = (<MontemarSummary />);
                }
                break;
            default:
                summaryComponent = (<Summary />)
        }


        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="col-md-12 col-lg-12 text-center checkout-header" >
                        <div className="header-img" >
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                        </div>
                        <div className="header-message">
                            <FormattedHTMLMessage id="app.step_checkout" description="Checkout info" values={{ nameClient: clientName, }} />
                        </div>
                        <div className='show-mobile-progress-bar'><FlowProgressBar /></div>
                    </div>
                </div>
                <Row className="checkout-form flex-lg-column">
                    <Col className="terms-container " xs={12} md={8} lg={12}>
                        {summaryComponent}
                    </Col>

                    <Col xs={12} md={4} lg={12}>
                        <Row>
                            <Col className="terms-container" xs={12} md={12}>
                                <div className='show-desktop-progress-bar'><FlowProgressBar /></div>
                                <ContractsContainer />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Section>
        );
    }
}

CheckOut = TopScrolleable(CheckOut);

CheckOut = LeadInfo(CheckOut);

CheckOut = withAuthControl(CheckOut);

export default CheckOut;



/** WEBPACK FOOTER **
 ** ./src/components/CheckOut.js
 **/